import { render, staticRenderFns } from "./add-service-type.vue?vue&type=template&id=8c8aa95c&scoped=true&"
import script from "./add-service-type.vue?vue&type=script&lang=js&"
export * from "./add-service-type.vue?vue&type=script&lang=js&"
import style0 from "./add-service-type.vue?vue&type=style&index=0&id=8c8aa95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8aa95c",
  null
  
)

export default component.exports